/** External dependencies */
// see extended comment in ct_iframe/assets/src/js/button.ts as to why we for now have to ignore the following line
// @ts-ignore
import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';

/** Internal dependencies */
import { whenDocumentReady } from 'assets/src/scripts/utilities/whenDocumentReady';

whenDocumentReady(initWidget);

function initWidget() {
    Fancybox.bind('[data-fancybox]', {
        youtube: {
            rel: 0,
            modestbranding: 1,
            controls: 1,
            showinfo: 0,
            iv_load_policy: 3,
        },
    });
}
